const IMG = '/images/contact';

const page = {
  slug: 'contact-form-general',
  title: 'Contact Us',
  blocks: [
    { type: 'marquee', text: 'CONTACT US' },
    {
      type: 'split',
      collageVariant: 'rect',
      images: [
        { image: `${IMG}/contact-us2.webp`, imageAlt: 'A plated dish from a Square Fare catering event' },
        { image: `${IMG}/contact-us1.webp`, imageAlt: 'Catering trays being plated' },
      ],
      groups: [
        {
          paragraphs: [
            'Do you have questions about what Square Fare can do for you?',
            'Email us at claire@getsquarefare.com or fill out the form below.',
            'Or give us a call at (917) 679-5306',
            'We look forward to hearing from you.',
          ],
        },
      ],
      form: { formType: 'general' },
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Visit FAQ', to: '/faqs' },
        { label: 'How To Order', to: '/how-to-order', variant: 'outline' },
      ],
    },
  ],
};

export default page;
